export const grants = ['create_company', 'edit_company', 'delete_company', 'read_companies']

export default grants
